// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"93e0b8f3","182":"d4551a03","488":"f4b4354c","508":"5d0d9ecc","859":"962efc6e"}[chunkId] + ".chunk.js";
};